import { IShellDAO } from '../../../dao/IShellDAO';
import { GrantHistoryType } from './types';
import { AbstractRepository } from '../../../core/repositories/AbstractRepository';
import { internalLogger } from '../../../interface/v1/clientOsLogger';

export class GrantHistoryRepository extends AbstractRepository<
  GrantHistoryType[]
> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellGrantHistory',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantHistoryRepository',
      methodName: 'saveAll()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): GrantHistoryType[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantHistoryRepository',
      methodName: 'findAll()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantHistoryRepository',
      methodName: 'delete()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
